import Image4 from '../inTheAttic/bedroom.webp'
import Image5 from '../inTheAttic/bedroom2.webp'
import Image6 from '../inTheAttic/bedroom3.webp'
import Image7 from '../inTheAttic/bedroom4.webp'
import Image8 from '../inTheAttic/bedroom5.webp'
import Image9 from '../inTheAttic/bedroom6.webp'
import Image10 from '../inTheAttic/bedroom7.webp'
import Image11 from '../inTheAttic/hallway.webp'
import Image12 from '../inTheAttic/kitchen.webp'
import Image13 from '../inTheAttic/kitchen2.webp'
import Image14 from '../inTheAttic/kitchen3.webp'
import Image15 from '../inTheAttic/kitchen4.webp'
import Image16 from '../inTheAttic/kitchen5.webp'
import Image17 from '../inTheAttic/kitchen6.webp'
import Image18 from '../inTheAttic/livingroom.webp'
import Image19 from '../inTheAttic/livingroom2.webp'
import Image20 from '../inTheAttic/livingroom3.webp'
import Image21 from '../inTheAttic/livingroom4.webp'
import Image22 from '../inTheAttic/livingroom5.webp'
import Image23 from '../inTheAttic/livingroom6.webp'
import Image24 from '../inTheAttic/outside.webp'
import Image25 from '../inTheAttic/stairway.webp'
import Image26 from '../inTheAttic/stairway2.webp'
import Image27 from '../inTheAttic/stairway3.webp'

const ApartmentThreeImages = [
    {
        id: 18,
        image: Image18,
    }, {
        id: 19,
        image: Image19,
    }, {
        id: 20,
        image: Image20,
    }, {
        id: 21,
        image: Image21,
    }, {
        id: 22,
        image: Image22,
    }, {
        id: 23,
        image: Image23,
    }, {
    id: 4,
    image: Image4,
  }, {
    id: 5,
    image: Image5,
  }, {
    id: 6,
    image: Image6,
  }, {
    id: 7,
    image: Image7,
  }, {
    id: 8,
    image: Image8,
  }, {
    id: 9,
    image: Image9,
  }, {
    id: 10,
    image: Image10,
  }, {
    id: 11,
    image: Image11,
  }, {
    id: 12,
    image: Image12,
  }, {
    id: 13,
    image: Image13,
  }, {
    id: 14,
    image: Image14,
  }, {
    id: 15,
    image: Image15,
  }, {
    id: 16,
    image: Image16,
  }, {
    id: 17,
    image: Image17,
  },{
    id: 24,
    image: Image24,
  }, {
    id: 25,
    image: Image25,
  }, {
    id: 26,
    image: Image26,
  }, {
    id: 27,
    image: Image27,
  }
]

export default ApartmentThreeImages
